import { CommonModule } from '@angular/common';
import {
  FormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { passwordMatchValidator } from '../../../validators/password-match-validator';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DashboardCategoriesModel } from '../../../../core/models/user/dashboard-categories.model';
import { UserSessionModel } from '../../../../core/models/user/current-user.model';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { ToastService } from '../../../../core/services/toast.service';
import { WelcomeImageComponent } from '../../../components/welcome-image/welcome-image.component';
@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    WelcomeImageComponent,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent {
  categories: DashboardCategoriesModel[] = [];
  currentUser: UserSessionModel | null = null;
  resetPasswordForm: FormGroup;
  email: string = '';
  code: string = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private toastService: ToastService
  ) {
    const userLang = localStorage.getItem('app-lang') || 'en-US';
    this.translate.use(userLang);

    this.resetPasswordForm = this.fb.group(
      {
        email: [''],
        code: [''],
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/
            ),
          ],
        ],
        confirmPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              /^^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/
            ),
          ],
        ],
      },
      { validators: passwordMatchValidator }
    );
  }

  sendResetCode: boolean = false;
  currentYear: number = new Date().getFullYear();

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.email = params['email'];
      this.code = params['code'];
      this.setResetPasswordForm();
    });
  }

  setResetPasswordForm() {
    this.resetPasswordForm.controls['email'].setValue(this.email);
    this.resetPasswordForm.controls['code'].setValue(this.code);
  }

  submitNewPassword(e: Event): void {
    e.preventDefault();
    this.authService.resetPassword(this.resetPasswordForm.value).subscribe({
      next: async () => {
        this.toastService.showToast(
          this.translate.instant('resetPassword.newPasswordSetted'),
          'success'
        );

        setTimeout(() => {
          this.router.navigate(['/auth/login']);
        }, 2000);
      },
    });
  }

  isResetPasswordControlInvalid(controlName: string): boolean {
    const control = this.resetPasswordForm.get(controlName);
    return control ? control.invalid && control.touched : false;
  }
}
